module.exports = __webpack_public_path__ + "assets/breadcrumbs-arrow.cb99c27e.svg";